import httpService from "../utils/httpService";

export const startSessionAsync = async (widgetKey, userName, email, role, testRoles, testPrompt) => {
    const body =  {
      widgetKey,
      userName,
      email,
      role,
      testRoles,
      testPrompt
    };

    const response = await httpService.post('/session/start', body);
    return response.data;
  };

  // Silent-auth equivalent of startSessionAsync. The kanisAuthToken in the body is a single-use
  // credential minted by Kanis on behalf of an upstream caller (e.g. LiveSign) that has already
  // authenticated the end-user. Kanis consumes it and returns a ChatSession JWT bound to that user.
  // Returns the whole response.data so callers can inspect { succeeded, result, errors }.
  export const startSessionWithAuthTokenAsync = async (widgetKey, kanisAuthToken) => {
    const body = { widgetKey, kanisAuthToken };
    const response = await httpService.post('/session/start-with-auth-token', body);
    return response.data;
  };

  export const endSessionAsync = async () => {
    const response = await httpService.post('/session/end', null);
    const resObj = response.data;
    if (!resObj.succeeded) {
      throw new Error(resObj.errors[0]);
    }
    return resObj.result;
  };

  export const sendChatMessageAsync = async (message) => {
    const response = await httpService.post('/session/message', { message });
    const resObj = response.data;
    if (!resObj.succeeded) {
      throw new Error(resObj.errors[0]);
    }
    return resObj.result;
  };

  export const startChatAsync = async () => {
    const response = await httpService.post('/session/start-chat', null);
    const resObj = response.data;
    if (!resObj.succeeded) {
      throw new Error(resObj.errors[0]);
    }
    return resObj.result;
  };

  export const endChatAsync = async (chatId) => {
    const response = await httpService.post(`/session/chat/${chatId}/end`, null);
    const resObj = response.data;
    if (!resObj.succeeded) {
      throw new Error(resObj.errors[0]);
    }
    return resObj.result;
  };

  export const getActiveChatAsync = async () => {
    const response = await httpService.get('/session/active-chat');
    const resObj = response.data;
    if (!resObj.succeeded) {
      throw new Error(resObj.errors[0]);
    }
    return resObj.result;
  };

  export const requestAgentAsync = async (chatId) => {
    const response = await httpService.post(
      `/session/chat/${chatId}/request-agent`,
      null
    );
    const resObj = response.data;
    if (!resObj.succeeded) {
      throw new Error(resObj.errors[0]);
    }
    return resObj.result;
  };

  export const optOutTranscriptAsync = async (optOut) => {
    const response = await httpService.post(
      `/session/transcript/${optOut}`,
      null
    );
    const resObj = response.data;
    if (!resObj.succeeded) {
      throw new Error(resObj.errors[0]);
    }
    return resObj.result;
  };